(() => {
  'use strict';
  const routeRoot = window.Shopify?.routes?.root || '/';
  const cartDialog = document.getElementById('tp-cart-dialog');
  const sectionId = cartDialog?.dataset.tpSectionId;
  const canDraw = !!(cartDialog && typeof cartDialog.showModal === 'function');
  const cartPageSections = ['main-cart-items', 'main-cart-footer'].map(id => ({id, section: document.getElementById(id)?.dataset.id})).filter(item => item.section);
  const cartSectionIds = [sectionId, ...cartPageSections.map(item => item.section)].filter(Boolean);
  const busyForms = new WeakSet();
  const purchaseFocus = new WeakMap();
  let returnFocus;
  let queue = Promise.resolve();
  let filterRequest;
  const catalogDialog = document.getElementById('tp-catalog-dialog');
  const canCatalog = !!(catalogDialog && typeof catalogDialog.showModal === 'function');
  const catalogPanels = new Map([...(catalogDialog?.querySelectorAll('[data-tp-catalog-panel]') || [])].map(panel => [panel.dataset.tpCatalogPanel, panel]));
  let catalogPath = ['root'];
  let catalogReturnFocus;
  const catalogTriggers = new Map();
  let catalogRequest;
  let catalogSession = 0;

  function catalogLoading(message = '') {
    const status = catalogDialog.querySelector('[data-tp-catalog-load-status]');
    status.textContent = message;
    status.hidden = !message;
    catalogDialog.querySelector('.tp-catalog-panels').setAttribute('aria-busy', String(!!catalogRequest));
  }

  async function nextCatalogLevel(trigger) {
    const id = trigger.dataset.tpCatalogNext;
    const session = catalogSession;
    if (catalogRequest) return;
    try {
      if (!catalogPanels.has(id)) {
        const url = new URL(trigger.dataset.tpCatalogSource || trigger.href, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Destinație invalidă.');
        url.searchParams.set('section_id', 'tp-catalog-level');
        catalogRequest = new AbortController();
        catalogLoading('Se încarcă…');
        const response = await fetch(url.href, {credentials:'same-origin',headers:{Accept:'text/html'},signal:catalogRequest.signal});
        if (!response.ok) throw new Error('Catalogul nu s-a putut încărca. Reîncearcă.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const panel = [...doc.querySelectorAll('[data-tp-catalog-panel]')].find(node => node.dataset.tpCatalogPanel === id);
        if (!panel) throw new Error('Catalogul nu s-a putut încărca. Reîncearcă.');
        panel.classList.add('tp-catalog-panel');
        panel.inert = true;
        panel.setAttribute('aria-hidden','true');
        catalogDialog.querySelector('.tp-catalog-panels').append(panel);
        catalogPanels.set(id, panel);
        // Establish the off-screen frame before applying the slide transition.
        void panel.offsetWidth;
      }
      if (session !== catalogSession) return;
      catalogTriggers.set(id, trigger);
      catalogPath.push(id);
      catalogLevel();
      catalogPanels.get(id).scrollTop = 0;
      catalogDialog.querySelector('[data-tp-catalog-heading]').focus({preventScroll:true});
    } catch(error) {
      if (error.name !== 'AbortError') catalogLoading(error.message);
    } finally {
      catalogRequest = null;
      catalogDialog.querySelector('.tp-catalog-panels').setAttribute('aria-busy','false');
      const status = catalogDialog.querySelector('[data-tp-catalog-load-status]');
      if (status.textContent === 'Se încarcă…') catalogLoading();
    }
  }

  function catalogLevel() {
    const current = catalogPath.at(-1);
    catalogPanels.forEach((panel, id) => {
      const active = id === current;
      panel.classList.toggle('is-current', active);
      panel.classList.toggle('is-before', !active && catalogPath.includes(id));
      panel.inert = !active;
      panel.setAttribute('aria-hidden', String(!active));
    });
    const title = catalogPanels.get(current)?.dataset.tpPanelTitle || 'Catalog';
    catalogDialog.querySelector('[data-tp-catalog-heading]').textContent = title;
    catalogDialog.querySelector('[data-tp-catalog-back]').hidden = catalogPath.length === 1;
  }

  function openCatalog(trigger) {
    if (!canCatalog) return;
    if (cartDialog?.open) cartDialog.close();
    catalogReturnFocus = trigger;
    catalogSession++;
    catalogPath = ['root'];
    catalogTriggers.clear();
    catalogLevel();
    catalogPanels.get('root').scrollTop = 0;
    if (!catalogDialog.open) catalogDialog.showModal();
    document.documentElement.classList.add('tp-catalog-is-open');
    catalogDialog.querySelector('[data-tp-catalog-close]').focus();
  }

  catalogDialog?.addEventListener('close', () => {
    catalogSession++;
    catalogRequest?.abort();
    catalogLoading();
    document.documentElement.classList.remove('tp-catalog-is-open');
    if (catalogReturnFocus?.isConnected) catalogReturnFocus.focus({preventScroll: true});
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-tp-brand-search]')) return;
    const query = event.target.value.trim().toLocaleLowerCase('ro').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    event.target.closest('[data-tp-catalog-panel]').querySelectorAll('.tp-visual-grid--brands .tp-visual-card').forEach(card => {
      const text = card.textContent.toLocaleLowerCase('ro').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
      card.hidden = !text.includes(query);
    });
  });
  window.matchMedia('(max-width: 767px)').addEventListener('change', event => {
    if (!event.matches && catalogDialog?.open) catalogDialog.close();
  });

  function announce(message) {
    const status = document.querySelector('[data-tp-status]');
    if (status) status.textContent = message;
  }

  function serialize(task) {
    const next = queue.then(task);
    queue = next.catch(() => {});
    return next;
  }

  async function request(url, options = {}) {
    const response = await fetch(url, {
      credentials: 'same-origin', ...options,
      headers: { Accept: 'application/json', ...options.headers }
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Operația nu a putut fi confirmată.');
    return data;
  }

  function showDrawer(trigger) {
    if (!canDraw) { window.location.assign(routeRoot + 'cart'); return; }
    if (catalogDialog?.open) catalogDialog.close();
    if (!cartDialog.open) {
      returnFocus = trigger || document.activeElement;
      cartDialog.showModal();
      document.documentElement.classList.add('tp-cart-is-open');
      cartDialog.querySelector('[data-tp-cart-close]')?.focus();
    }
  }

  function cartError(message) {
    const error = cartDialog?.querySelector('[data-tp-cart-error]');
    if (error) { error.textContent = message; error.hidden = false; }
    announce(message);
  }

  async function renderCart(data) {
    let sections = data?.sections;
    let html = sections?.[sectionId];
    // Rendering can fail after a successful mutation. Never retry the mutation.
    if (!html) {
      const url = new URL(window.location.href);
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', cartSectionIds.join(','));
      sections = await request(url.href, { headers: { Accept: 'text/html' } });
      html = sections[sectionId];
    }
    if (!html) throw new Error('Coșul s-a actualizat, dar afișarea nu s-a putut reîncărca. Verifică pagina Coș.');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const updated = doc.querySelector('[data-tp-cart-content]');
    if (!updated) throw new Error('Lipsește conținutul coșului. Verifică pagina Coș.');
    const active = document.activeElement;
    const focusWasInside = cartDialog.contains(active);
    const scroll = cartDialog.querySelector('.tp-cart-scroll')?.scrollTop || 0;
    cartDialog.querySelector('[data-tp-cart-content]').replaceWith(updated);
    const nextScroll = cartDialog.querySelector('.tp-cart-scroll');
    if (nextScroll) nextScroll.scrollTop = scroll;
    const count = Number(updated.dataset.count) || 0;
    cartPageSections.forEach(item => {
      if (!sections?.[item.section]) return;
      const source = new DOMParser().parseFromString(sections[item.section], 'text/html');
      const target = document.getElementById(item.id);
      const fresh = source.getElementById(item.id);
      const contents = target?.querySelector('.js-contents');
      const newContents = fresh?.querySelector('.js-contents');
      if (contents && newContents) contents.replaceWith(newContents);
      if (target) target.classList.toggle('is-empty', count === 0);
      if (item.id === 'main-cart-items') document.querySelector('cart-items')?.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('[data-tp-cart-count]').forEach(node => {
      node.textContent = String(count);
      node.hidden = count === 0;
    });
    if (focusWasInside && cartDialog.open) cartDialog.querySelector('[data-tp-cart-close]')?.focus();
    document.dispatchEvent(new CustomEvent('tp:cart-updated', { detail: { itemCount: count } }));
  }

  function formError(form, message) {
    let error = form.querySelector('[data-tp-form-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'tp-error';
      error.dataset.tpFormError = '';
      error.setAttribute('role', 'alert');
      form.append(error);
    }
    error.textContent = message;
    error.hidden = !message;
  }

  function markBusy(form) {
    const controls = [...form.querySelectorAll('button[type="submit"], input[type="submit"], input[type="radio"]')];
    const sticky = form.closest('[data-tp-product]')?.querySelector('[data-tp-sticky-submit]');
    if (sticky) controls.push(sticky);
    const states = controls.map(control => [control, control.disabled]);
    states.forEach(([control]) => { control.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    return () => {
      states.forEach(([control, disabled]) => { control.disabled = disabled; });
      form.removeAttribute('aria-busy');
    };
  }

  function isAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = new URL(form.action, window.location.href);
    return action.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(action.pathname);
  }

  function pulseSuccess(form, submitter) {
    const buttons = new Set();
    if (submitter instanceof HTMLElement && submitter.matches('button')) buttons.add(submitter);
    const stickyBtn = form.closest('[data-tp-product]')?.querySelector('[data-tp-sticky-submit]');
    if (stickyBtn) buttons.add(stickyBtn);
    buttons.forEach(btn => {
      btn.classList.remove('tp-button--success');
      void btn.offsetWidth;
      btn.classList.add('tp-button--success');
      setTimeout(() => btn.classList.remove('tp-button--success'), 900);
    });
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!isAddForm(form) || !canDraw) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busyForms.has(form)) return;
    if (form.matches('[data-tp-product-form]') && !form.querySelector('[name="id"]').value) {
      formError(form, 'Alege o mărime disponibilă.');
      form.querySelector('[data-tp-options] input:not(:disabled)')?.focus();
      return;
    }
    if (!form.reportValidity()) return;
    const body = new FormData(form);
    body.set('sections', cartSectionIds.join(','));
    body.set('sections_url', window.location.pathname + window.location.search);
    busyForms.add(form);
    const focusTarget = purchaseFocus.get(form) || form.closest('details.tp-quick-add')?.querySelector('summary') || event.submitter || document.activeElement;
    purchaseFocus.delete(form);
    formError(form, '');
    const release = markBusy(form);
    serialize(async () => {
      let accepted = false;
      try {
        const data = await request(routeRoot + 'cart/add.js', { method: 'POST', body });
        accepted = true;
        pulseSuccess(form, event.submitter);
        showDrawer(focusTarget);
        await renderCart(data);
        form.closest('details.tp-quick-add')?.removeAttribute('open');
        announce('Produs adăugat în coș.');
      } catch (error) {
        if (accepted) cartError('Produs adăugat. ' + error.message);
        else formError(form, error instanceof TypeError ? 'Nu am putut confirma adăugarea. Verifică coșul înainte de a reîncerca.' : error.message);
      } finally {
        busyForms.delete(form);
        release();
      }
    });
  }, true);

  document.addEventListener('click', event => {
    const catalogOpener = event.target.closest('[data-tp-catalog-open]');
    if (canCatalog && catalogOpener && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault(); event.stopImmediatePropagation();
      openCatalog(catalogOpener);
      return;
    }
    const catalogNext = event.target.closest('[data-tp-catalog-next]');
    if (catalogNext && catalogDialog?.open && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault(); event.stopImmediatePropagation();
      nextCatalogLevel(catalogNext);
      return;
    }
    if (event.target.closest('[data-tp-catalog-back]')) {
      catalogRequest?.abort();
      if (catalogPath.length < 2) return;
      const previous = catalogPath.pop();
      catalogLevel();
      catalogTriggers.get(previous)?.focus({preventScroll: true});
      return;
    }
    if (event.target.closest('[data-tp-catalog-close]')) { catalogDialog?.close(); return; }
    const fullCart = event.target.closest('a[data-tp-cart-page]');
    if (fullCart && cartDialog?.open) {
      const target = new URL(fullCart.href);
      if (target.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '')) {
        event.preventDefault(); event.stopImmediatePropagation();
        cartDialog.close();
        const destination = target.hash ? document.getElementById(target.hash.slice(1)) : document.querySelector('main');
        destination?.scrollIntoView({behavior: 'smooth', block: 'start'});
        if (target.hash) history.replaceState(history.state, '', target.href);
        return;
      }
    }
    const opener = event.target.closest('[data-tp-cart-open], a[href]');
    const cartLink = opener?.matches('a[href]') && new URL(opener.href).origin === window.location.origin && /\/cart\/?$/.test(new URL(opener.href).pathname);
    if (canDraw && opener && !opener.hasAttribute('data-tp-cart-page') && (opener.hasAttribute('data-tp-cart-open') || cartLink) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showDrawer(opener);
      serialize(() => renderCart()).catch(error => cartError(error.message));
      return;
    }
    if (event.target.closest('[data-tp-cart-close]')) cartDialog?.close();
    const lineButton = event.target.closest('[data-tp-line]');
    if (lineButton && !lineButton.disabled && canDraw) {
      const id = lineButton.dataset.tpLine;
      const quantity = Number(lineButton.dataset.tpQuantity);
      const controls = [...cartDialog.querySelectorAll('[data-tp-line]')];
      controls.forEach(control => { control.disabled = true; });
      serialize(async () => {
        try {
          const data = await request(routeRoot + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, quantity, sections: cartSectionIds, sections_url: window.location.pathname + window.location.search })
          });
          await renderCart(data);
          announce('Coș actualizat.');
        } catch (error) { cartError(error.message); }
        finally { controls.forEach(control => { control.disabled = false; }); }
      });
    }
    document.querySelectorAll('.tp-quick-add[open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  }, true);

  cartDialog?.addEventListener('close', () => {
    document.documentElement.classList.remove('tp-cart-is-open');
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  });
  let backdropPress = false;
  cartDialog?.addEventListener('pointerdown', event => { backdropPress = event.target === cartDialog; });
  cartDialog?.addEventListener('click', event => {
    if (backdropPress && event.target === cartDialog) cartDialog.close();
    backdropPress = false;
  });

  function initializeRails(scope = document) {
    scope.querySelectorAll('[data-tp-app-card-rail]').forEach(rail => {
      if (rail.dataset.tpReady) return;
      rail.dataset.tpReady = 'true';
      const links = [...rail.querySelectorAll('.tp-app-card-slide')];
      const dots = [...rail.closest('[data-tp-app-card]').querySelectorAll('.tp-app-card-dots span')];
      let frame = 0;
      let start;
      let dragging = false;
      let blockClickUntil = 0;
      rail.addEventListener('pointerdown', event => { start = [event.clientX, event.clientY]; dragging = false; }, { passive: true });
      rail.addEventListener('pointermove', event => {
        if (!start) return;
        const dx = Math.abs(event.clientX - start[0]);
        const dy = Math.abs(event.clientY - start[1]);
        if (dx > 10 && dx > dy) dragging = true;
      }, { passive: true });
      const finish = () => { if (dragging) blockClickUntil = Date.now() + 500; start = null; };
      rail.addEventListener('pointerup', finish, { passive: true });
      rail.addEventListener('pointercancel', finish, { passive: true });
      rail.addEventListener('click', event => {
        if (Date.now() < blockClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      rail.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const liveLinks = [...rail.querySelectorAll('.tp-app-card-slide')];
          const liveDots = [...rail.closest('[data-tp-app-card]').querySelectorAll('.tp-app-card-dots span')];
          const index = Math.min(liveLinks.length - 1, Math.max(0, Math.round(rail.scrollLeft / (rail.clientWidth || 1))));
          liveDots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          liveLinks.forEach((link, i) => { link.tabIndex = i === index ? 0 : -1; });
        });
      }, { passive: true });
    });
  }

  function initializeFilters(scope = document, retainOpen = false) {
    scope.querySelectorAll('[data-tp-filter-drawer]').forEach(drawer => {
      if (!window.matchMedia('(max-width: 767px)').matches || retainOpen) drawer.open = true;
      else drawer.open = false;
    });
  }

  async function loadCollection(root, url, pushHistory = true) {
    const autoNav = Date.now() < (window.__tpAutoUntil || 0);   /* 30.10.2026: filtrele aplicate automat la incarcare inlocuiesc intrarea din istoric (Inapoi = o singura apasare) */
    filterRequest?.abort();
    const controller = new AbortController();
    filterRequest = controller;
    const focus = document.activeElement;
    const focusIdentity = focus?.name ? { name: focus.name, value: focus.value } : null;
    const section = root.dataset.tpSectionId;
    const filtersOpen = root.querySelector('[data-tp-filter-drawer]')?.open;
    const groupState = {};
    root.querySelectorAll('details.tp-fdetails[data-fkey]').forEach(d => { groupState[d.dataset.fkey] = d.open; });
    const endpoint = new URL(url);
    endpoint.searchParams.set('sections', section);
    root.setAttribute('aria-busy', 'true');
    try {
      const data = await request(endpoint.href, { signal: controller.signal, headers: { Accept: 'text/html' } });
      const html = data[section];
      if (!html) throw new Error('Section rendering unavailable');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = [...doc.querySelectorAll('[data-tp-collection]')].find(node => node.dataset.tpSectionId === section);
      if (!replacement) throw new Error('Collection markup unavailable');
      root.replaceWith(replacement);
      if (pushHistory) history[autoNav ? 'replaceState' : 'pushState']({ tpCollection: true }, '', url);
      initializeRails(replacement);
      initializeFilters(replacement, filtersOpen);
      replacement.querySelectorAll('details.tp-fdetails[data-fkey]').forEach(d => { if (d.dataset.fkey in groupState) d.open = groupState[d.dataset.fkey] || d.open; });
      if (focusIdentity) [...replacement.querySelectorAll('input, select')].find(node => node.name === focusIdentity.name && node.value === focusIdentity.value)?.focus({ preventScroll: true });
      announce(replacement.querySelector('[data-tp-results-count]')?.textContent || 'Produse actualizate.');
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(url);
    } finally {
      root.removeAttribute('aria-busy');
      if (filterRequest === controller) filterRequest = null;
    }
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-tp-filters]');
    if (!form) return;
    event.preventDefault();
    const url = new URL(form.action);
    const view = new URL(window.location.href).searchParams.get('view');
    if (view) url.searchParams.set('view', view);
    const seen = new Set();
    for (const [key, value] of new FormData(form)) {
      if (value === '') continue;
      const id = key + '=' + value;
      if (seen.has(id)) continue;
      seen.add(id);
      url.searchParams.append(key, value);
    }
    loadCollection(form.closest('[data-tp-collection]'), url.href);
  });
  // Culoare = grup de variante: bifa grupului (Negru) aplica toate valorile brute din grup (Negru lac, Black ...).
  document.addEventListener('change', event => {
    const group = event.target;
    if (!(group instanceof HTMLInputElement) || !group.matches('[data-tp-color-group]')) return;
    const scope = group.closest('fieldset');
    if (!scope) return;
    const wanted = new Set();
    scope.querySelectorAll('[data-tp-color-group]').forEach(g => {
      if (g.checked) g.closest('.tp-filter-option').querySelectorAll('input[data-tp-color-raw]:not(:disabled)').forEach(raw => wanted.add(raw.name + '=' + raw.value));
    });
    scope.querySelectorAll('input[data-tp-color-raw]:not(:disabled)').forEach(raw => { raw.checked = wanted.has(raw.name + '=' + raw.value); });
  }, true);
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-tp-filters]');
    if (form && (event.target.matches('input[type="checkbox"]') || event.target.name === 'sort_by')) form.requestSubmit();
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('.tp-pagination a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const root = link.closest('[data-tp-collection]');
    if (!root) return;
    event.preventDefault();
    /* 30.10.2026: dupa schimbarea paginii, derulam la inceputul rezultatelor (inainte ramaneai la coada paginii noi) */
    loadCollection(root, link.href).then(() => {
      const r = document.querySelector('[data-tp-collection]');
      if (r) window.scrollTo({ top: Math.max(0, r.getBoundingClientRect().top + window.scrollY - 70), behavior: 'auto' });
    });
  });
  window.addEventListener('popstate', () => {
    if (window.__tpSkipPop) return;
    const root = document.querySelector('[data-tp-collection]');
    if (root) loadCollection(root, window.location.href, false);
  });

  /* 02.11.2026 gallery-v2: galeria paginii de produs, refacuta sa mearga mereu.
     Indexul e sursa de adevar (nu pozitia de scroll): sagetile, tastele si schimbarea variantei il seteaza pe loc,
     fara rAF si fara sa astepte smooth-scroll-ul; apoi deruleaza, iar un watchdog potriveste pozitia daca animatia
     nu ajunge (tab in fundal, scroll intrerupt). Swipe-ul ramane nativ (scroll-snap) si doar citeste pozitia. */
  function initGallery(root) {
    const gallery = root.querySelector('[data-tp-pdp-gallery]');
    if (!gallery || gallery.__tpGal) return;
    const slides = [...gallery.querySelectorAll('.tp-pdp-slide')];
    if (slides.length < 2) return;
    const wrap = gallery.closest('[data-tp-pdp-gallery-wrap]') || root;
    const prevBtn = wrap.querySelector('[data-tp-pdp-prev]');
    const nextBtn = wrap.querySelector('[data-tp-pdp-next]');
    const counterCurrent = wrap.querySelector('[data-tp-pdp-counter-current]');
    const reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    const last = slides.length - 1;
    let index = 0, pending = null, settleTimer = 0, watchdog = 0, lastScrollAt = 0;

    const live = document.createElement('span');
    live.className = 'tp-pdp-sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
    wrap.appendChild(live);
    gallery.setAttribute('role', 'region'); gallery.setAttribute('aria-roledescription', 'carusel');
    slides.forEach((s, i) => { s.setAttribute('role', 'group'); s.setAttribute('aria-roledescription', 'slide'); s.setAttribute('aria-label', (i + 1) + ' din ' + slides.length); });

    const step = () => gallery.getBoundingClientRect().width || gallery.clientWidth || 1;
    const maxLeft = () => Math.max(0, gallery.scrollWidth - gallery.clientWidth);
    const leftFor = i => Math.min(maxLeft(), Math.round(i * step()));
    const fromScroll = () => Math.max(0, Math.min(last, Math.round(gallery.scrollLeft / step())));

    // pozele vecine se incarca din timp, ca dupa o sageata sa nu apara un gol alb
    function warm(i) {
      for (let k = i - 1; k <= i + 2; k++) {
        const im = slides[k] && slides[k].querySelector('img');
        if (im && im.loading === 'lazy') { im.loading = 'eager'; if (im.decode) im.decode().catch(() => {}); }
      }
    }
    function paint() {
      const n = String(index + 1);
      if (counterCurrent && counterCurrent.textContent !== n) counterCurrent.textContent = n;
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= last;
      if (gallery.dataset.tpIndex !== String(index)) gallery.dataset.tpIndex = String(index);
    }
    function setIndex(i, announce) {
      i = Math.max(0, Math.min(last, i));
      if (i !== index) {
        const old = slides[index];
        index = i;
        slides.forEach((s, k) => s.classList.toggle('is-current', k === index));
        if (old) old.querySelectorAll('video').forEach(v => { if (!v.paused) v.pause(); });
        warm(index);
      }
      paint();
      if (announce) live.textContent = 'Poza ' + (index + 1) + ' din ' + slides.length;
    }
    function verify() {
      if (!pending) return;
      // inca deruleaza (smooth lung): mai asteptam, dar nu la nesfarsit
      if (Date.now() - lastScrollAt < 120 && Date.now() - pending.at < 2500) { watchdog = setTimeout(verify, 150); return; }
      const left = leftFor(pending.i);
      if (Math.abs(gallery.scrollLeft - left) > 2) { try { gallery.scrollTo({ left, behavior: 'auto' }); } catch (e) { gallery.scrollLeft = left; } }
      pending = null;
    }
    function goTo(i, opts) {
      opts = opts || {};
      i = Math.max(0, Math.min(last, Math.round(Number(i)) || 0));
      const smooth = !opts.instant && !reduce.matches;
      setIndex(i, opts.announce);
      const left = leftFor(i);
      clearTimeout(watchdog);
      if (Math.abs(gallery.scrollLeft - left) <= 2) { pending = null; return; }
      pending = { i, at: Date.now() };
      try { gallery.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { gallery.scrollLeft = left; }
      watchdog = setTimeout(verify, smooth ? 750 : 60);
    }
    function settle() {
      if (pending) {
        if (Math.abs(gallery.scrollLeft - leftFor(pending.i)) > 2) return; // verify() se ocupa
        pending = null; clearTimeout(watchdog);
      }
      setIndex(fromScroll());
    }

    // la schimbarea latimii (rotire, redimensionare) ramanem pe aceeasi poza, nu pe aceeasi pozitie in pixeli
    let knownW = step();
    function syncWidth() {
      const w = step();
      if (Math.abs(w - knownW) < 0.5) return false;
      knownW = w;
      if (!pending) {
        const left = leftFor(index);
        if (Math.abs(gallery.scrollLeft - left) > 2) { try { gallery.scrollTo({ left, behavior: 'auto' }); } catch (e) { gallery.scrollLeft = left; } }
      }
      return true;
    }
    gallery.addEventListener('scroll', () => {
      lastScrollAt = Date.now();
      if (!pending && !syncWidth()) setIndex(fromScroll());
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 130);
    }, { passive: true });
    gallery.addEventListener('scrollend', () => { clearTimeout(settleTimer); settle(); });
    // utilizatorul preia controlul (deget / rotita): renuntam la tinta programatica
    ['touchstart', 'wheel'].forEach(t => gallery.addEventListener(t, () => { pending = null; clearTimeout(watchdog); }, { passive: true }));

    prevBtn?.addEventListener('click', () => goTo(index - 1, { announce: true }));
    nextBtn?.addEventListener('click', () => goTo(index + 1, { announce: true }));

    // tastatura: sageti cand focusul e pe galerie, pe sageti sau liber pe pagina (dar nu intr-un camp, dialog sau lista)
    document.addEventListener('keydown', e => {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      let to = null;
      if (e.key === 'ArrowRight') to = index + 1; else if (e.key === 'ArrowLeft') to = index - 1; else if (e.key === 'Home') to = 0; else if (e.key === 'End') to = last;
      if (to === null || !gallery.isConnected) return;
      const t = e.target;
      const inside = !!(t && t.closest && t.closest('[data-tp-pdp-gallery-wrap]') === wrap);
      const free = t === document.body || t === document.documentElement;
      if (!inside && !free) return;
      if (free) {
        if (e.key === 'Home' || e.key === 'End') return; // pe pagina libera Home/End raman pentru derulare
        if (document.querySelector('dialog[open]')) return;
        const r = gallery.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
      }
      if (to < 0 || to > last) { if (inside) e.preventDefault(); return; }
      e.preventDefault();
      goTo(to, { announce: true });
    });

    if ('ResizeObserver' in window) new ResizeObserver(() => { syncWidth(); }).observe(gallery);
    window.addEventListener('pageshow', () => { if (!pending) setIndex(fromScroll()); });
    // plasa de siguranta: daca un eveniment de scroll/resize se pierde (tab in fundal, randare intarziata), starea se realiniaza oricum
    setInterval(() => {
      if (document.hidden || pending || !gallery.isConnected) return;
      if (syncWidth()) return;
      const i = fromScroll();
      if (i !== index) setIndex(i);
    }, 400);

    gallery.__tpGal = { goTo, get index() { return index; }, count: slides.length };
    setIndex(fromScroll());
    slides[index].classList.add('is-current');
    const idle = window.requestIdleCallback || (fn => setTimeout(fn, 400));
    const afterLoad = () => idle(() => warm(index));
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
  }

  /* step2-perf: cardurile se initializeaza doar cand se apropie de ecran (48 carduri x ~12 ascultatori = munca inutila la incarcare) */
  const tpCardIO = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      tpCardIO.unobserve(en.target);
      const fn = en.target.__tpInit;
      if (fn) { en.target.__tpInit = null; try { fn(); } catch (e) {} }
    });
  }, { rootMargin: '900px 0px' }) : null;
  function tpScheduleCards(scope, init) {
    scope.querySelectorAll('[data-tp-app-card]').forEach(card => {
      if (card.dataset.tpCardReady || card.__tpInit) return;
      if (!tpCardIO) { init(card); return; }
      card.__tpInit = () => init(card);
      const wake = () => { const fn = card.__tpInit; if (fn) { card.__tpInit = null; tpCardIO.unobserve(card); fn(); } };
      card.addEventListener('pointerenter', wake, { once: true, passive: true });
      card.addEventListener('touchstart', wake, { once: true, passive: true });
      card.addEventListener('focusin', wake, { once: true });
      tpCardIO.observe(card);
    });
  }

  function initializeCards(scope = document) {
    const reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    const tpInitCard = card => {
      if (card.dataset.tpCardReady) return;
      card.dataset.tpCardReady = 'true';
      const rail = card.querySelector('[data-tp-app-card-rail]');
      if (!rail) return;
      const slides = [...rail.querySelectorAll('.tp-app-card-slide')];
      const dots = [...card.querySelectorAll('.tp-app-card-dots span')];
      const prevBtn = card.querySelector('[data-tp-app-card-prev]');
      const nextBtn = card.querySelector('[data-tp-app-card-next]');
      if (slides.length < 2) return;

      let activeIndex = 0;
      let holdTimer = 0;
      let autoplayTimer = 0;
      let settleTimer = 0;
      let isHolding = false;
      let played = false;
      let warmed = false;

      // Pozele 2..5 sunt lazy: le incarcam la prima atingere ca sa nu apara gol gri dupa click pe sageata.
      function warm() {
        if (warmed) return;
        warmed = true;
        loadExtraImages();
        rail.querySelectorAll('img').forEach(img => { img.loading = 'eager'; if (img.decode) img.decode().catch(() => {}); });
      }
      function paint(i) {
        activeIndex = ((i % slides.length) + slides.length) % slides.length;
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === activeIndex));
      }
      // cardul are in HTML doar primele 5 poze; la prima atingere/hover aducem si restul pozelor produsului (max 10) ca previzualizarea sa le arate pe toate
      let extraPromise = null;
      const dotsWrap = card.querySelector('.tp-app-card-dots');
      function loadExtraImages() {
        if (extraPromise) return extraPromise;
        const link = card.querySelector('.tp-app-card-copy h3 a');
        let path;
        try { path = new URL(link.getAttribute('href'), location.origin).pathname; } catch (e) { extraPromise = Promise.resolve(); return extraPromise; }
        extraPromise = fetch(path + '.js', { credentials: 'same-origin' }).then(r => (r.ok ? r.json() : null)).then(data => {
          if (!data || !data.images) return;
          const alt = link.textContent.trim();
          data.images.slice(slides.length).forEach(src => {
            let u;
            try { u = new URL(src.startsWith('//') ? 'https:' + src : src, location.href); u.searchParams.set('width', '800'); } catch (e) { return; }
            const a = document.createElement('a');
            a.className = 'tp-app-card-slide';
            a.href = slides[0].getAttribute('href');
            a.tabIndex = -1;
            const img = document.createElement('img');
            img.alt = alt; img.decoding = 'async'; img.draggable = false; img.src = u.toString();
            a.appendChild(img);
            rail.appendChild(a);
            slides.push(a);
            if (dotsWrap) { const s = document.createElement('span'); dotsWrap.appendChild(s); dots.push(s); }
          });
        }).catch(() => {});
        return extraPromise;
      }
      // dupa trecerea prin poze: revine la prima poza si apare panoul (brand, pret, marimi, Cumpara-l acum)
      const pitch = card.querySelector('[data-tp-pitch]');
      let pitchTimer = 0;
      let lastTouch = false;
      function setPitchFocusable(on) { pitch?.querySelectorAll('a').forEach(a => { a.tabIndex = on ? 0 : -1; }); }
      function showPitch() {
        if (!pitch) return;
        goTo(0, false);
        card.classList.add('tp-app-card--pitch');
        pitch.setAttribute('aria-hidden', 'false');
        setPitchFocusable(true);
        clearTimeout(pitchTimer);
        if (lastTouch) pitchTimer = setTimeout(hidePitch, 6000);
      }
      function hidePitch() {
        if (!pitch) return;
        clearTimeout(pitchTimer);
        card.classList.remove('tp-app-card--pitch');
        pitch.setAttribute('aria-hidden', 'true');
        setPitchFocusable(false);
      }
      card.addEventListener('click', event => {
        if (!pitch || !card.classList.contains('tp-app-card--pitch')) return;
        if (event.target.closest('[data-tp-pitch]') && !event.target.closest('a') && pitch.dataset.href) { event.preventDefault(); location.href = pitch.dataset.href; }
      });
      function currentIndex() {
        const w = rail.clientWidth || 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(rail.scrollLeft / w)));
      }
      /* 02.11.2026 card-nav-v2: starea (activeIndex) se seteaza pe loc; un watchdog duce banda la poza tinta daca animatia nu ajunge */
      let railWatch = 0;
      function goTo(i, smooth) {
        warm();
        const idx = ((i % slides.length) + slides.length) % slides.length;
        paint(idx);
        const left = Math.min(Math.max(0, rail.scrollWidth - rail.clientWidth), Math.round(idx * (rail.getBoundingClientRect().width || 1)));
        const soft = !(smooth === false || reduceMotion);
        clearTimeout(railWatch);
        if (Math.abs(rail.scrollLeft - left) <= 2) return;
        try { rail.scrollTo({ left, behavior: soft ? 'smooth' : 'auto' }); } catch (e) { rail.scrollLeft = left; }
        railWatch = setTimeout(() => { if (Math.abs(rail.scrollLeft - left) > 2) rail.scrollLeft = left; }, soft ? 700 : 50);
      }
      ['touchstart', 'wheel'].forEach(t => rail.addEventListener(t, () => clearTimeout(railWatch), { passive: true }));
      function step(dir) {
        // pornim de la pozitia reala, nu de la un index vechi: click-uri rapide sau swipe nu mai deruteaza
        goTo(activeIndex + dir);
      }
      function stopAutoplay(reset) {
        cancelHoldTimer();
        if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = 0; }
        if (isHolding) {
          isHolding = false;
          card.classList.remove('tp-app-card--previewing');
          if (reset !== false && reset !== 'end') goTo(0, false);
        }
        if (reset !== 'end') played = false;
      }
      let holdToken = 0;
      function cancelHoldTimer() { holdToken++; if (holdTimer) { clearTimeout(holdTimer); holdTimer = 0; } }
      function startAutoplay() {
        // 1s pe poza, la toate produsele, indiferent cate poze au
        const stepMs = 1000;
        const smooth = undefined;
        isHolding = true;
        card.classList.add('tp-app-card--previewing');
        goTo(activeIndex + 1, smooth);
        // o singura trecere prin toate pozele (1s fiecare); la ultima ramane acolo si nu mai reporneste
        autoplayTimer = setInterval(() => {
          if (activeIndex >= slides.length - 1) { played = true; stopAutoplay('end'); showPitch(); return; }
          goTo(activeIndex + 1, smooth);
        }, stepMs);
      }
      // dupa 3 secunde cu cursorul pe card (desktop) sau cu cardul in zona centrala a ecranului (telefon), pozele se deruleaza 1/secunda
      function scheduleAutoplay() {
        cancelHoldTimer();
        if (isHolding || played) return;
        holdTimer = setTimeout(() => { holdTimer = 0; if (pressStart) { suppressClick = true; setTimeout(() => { suppressClick = false; }, 5000); } const tok = ++holdToken; loadExtraImages().then(() => { if (tok === holdToken && !isHolding) startAutoplay(); }); }, 3000);
      }

      ['pointerenter', 'touchstart', 'focusin'].forEach(evt => card.addEventListener(evt, warm, { passive: true, once: true }));

      // previzualizarea porneste doar la apasare lunga (3s) pe card, nu cand utilizatorul doar priveste
      let pressStart = null;
      let suppressClick = false;
      function endPress() { pressStart = null; stopAutoplay(); }
      function beginPress(x, y, target) {
        if (target.closest('button, summary, details, form')) return;
        pressStart = [x, y];
        suppressClick = false;
        played = false;
        scheduleAutoplay();
      }
      function movePress(x, y, limit) {
        if (pressStart && Math.hypot(x - pressStart[0], y - pressStart[1]) > limit) endPress();
      }
      // mouse: evenimentele mouse (nu se anuleaza cand browserul incearca sa traga poza/linkul); touch/pen: pointer events
      // PC: cursorul tinut 3s pe produs (fara click) porneste o singura trecere prin poze; la iesire revine la prima poza
      card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { played = false; scheduleAutoplay(); } });
      card.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        stopAutoplay();
        hidePitch();
        if (activeIndex !== 0) goTo(0, false);
      });
      card.addEventListener('mousedown', () => cancelHoldTimer());
      card.addEventListener('pointerdown', event => { lastTouch = event.pointerType !== 'mouse'; if (event.pointerType !== 'mouse') beginPress(event.clientX, event.clientY, event.target); }, { passive: true });
      card.addEventListener('pointermove', event => { if (event.pointerType !== 'mouse') movePress(event.clientX, event.clientY, 10); }, { passive: true });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(evt => card.addEventListener(evt, event => { if (event.pointerType !== 'mouse' && pressStart) endPress(); }, { passive: true }));
      /* step2-perf: fara drag nativ -> CSS (-webkit-user-drag) in tp-app-ui.css */
      card.addEventListener('dragstart', event => event.preventDefault());
      card.addEventListener('contextmenu', event => { if (isHolding || pressStart) event.preventDefault(); });
      card.addEventListener('click', event => { if (suppressClick) { suppressClick = false; event.preventDefault(); event.stopPropagation(); } }, true);
      rail.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
        else if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
      });

      [[prevBtn, -1], [nextBtn, 1]].forEach(([btn, dir]) => {
        if (!btn) return;
        // pointerdown pe sageata nu trebuie sa porneasca "tine apasat pentru previzualizare"
        btn.addEventListener('pointerdown', event => event.stopPropagation());
        btn.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); step(dir); });
      });

      rail.addEventListener('scroll', () => {
        // in timpul animatiei pastram indexul tinta; il sincronizam dupa ce se opreste scroll-ul (swipe manual)
        clearTimeout(settleTimer);
        settleTimer = setTimeout(() => { if (!isHolding) paint(currentIndex()); }, 120);
      }, { passive: true });
    };
    tpScheduleCards(scope, tpInitCard);
  }

  function initializeProduct(root) {
    if (root.dataset.tpReady) return;
    initGallery(root);
    const dataNode = root.querySelector('[data-tp-product-data]');
    if (!dataNode) return;
    const { variants, reference } = JSON.parse(dataNode.textContent);
    const form = root.querySelector('[data-tp-product-form]');
    const select = form.querySelector('[data-tp-native-variants]');
    const sizeIndex = Number(root.dataset.tpSizeIndex);
    const chooseLabel = sizeIndex >= 0 ? 'Alege mărimea' : 'Alege varianta';
    const groups = [...root.querySelectorAll('[data-tp-option-index]')];
    const main = form.querySelector('[data-tp-main-atc]');
    const sticky = root.querySelector('[data-tp-sticky]');
    const stickyButton = sticky.querySelector('[data-tp-sticky-submit]');
    root.dataset.tpReady = 'true';
    select.hidden = true;
    select.required = false;
    root.querySelector('[data-tp-native-label]').hidden = true;
    root.querySelector('[data-tp-options]').hidden = false;

    function choices() { return groups.map(group => group.querySelector('input:checked')?.value || null); }
    function match(values) {
      return variants.find(variant => variant.options.every((value, index) => value === values[index]));
    }
    function measurement(variant) {
      const box = root.querySelector('[data-tp-measurements]');
      const values = box.querySelector('[data-tp-measurement-values]');
      const sources = box.querySelector('[data-tp-measurement-sources]');
      values.replaceChildren(); sources.replaceChildren();
      const row = (label, number, suffix) => {
        if (!(Number(number) > 0)) return;
        const p = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = `${number} cm`;
        p.append(`${label}: `, strong, suffix);
        values.append(p);
      };
      const source = (url, label) => {
        const link = document.createElement('a');
        link.href = url; link.textContent = label; sources.append(link);
      };
      if (variant?.proof_url && Number(variant.insole) > 0) {
        row('Lungime branț', variant.insole, sizeIndex >= 0 ? ` - mărimea ${variant.options[sizeIndex]}` : '');
        source(variant.proof_url, 'Fotografia branțului');
      }
      if (reference.proof_url && reference.size && (Number(reference.heel) > 0 || Number(reference.shaft) > 0)) {
        row('Înălțime toc', reference.heel, ` - măsurat la mărimea ${reference.size}`);
        row('Înălțime carâmb', reference.shaft, ` - măsurat la mărimea ${reference.size}`);
        source(reference.proof_url, 'Fotografia măsurătorii de referință');
      }
      box.hidden = values.children.length === 0;
    }
    function update(variant) {
      const selected = choices();
      groups.forEach(group => {
        const index = Number(group.dataset.tpOptionIndex);
        group.querySelectorAll('input').forEach(input => {
          input.disabled = !variants.some(v => v.available && v.options[index] === input.value && v.options.every((value, i) => i === index || i === sizeIndex || selected[i] === null || value === selected[i]));
        });
      });
      select.value = variant ? String(variant.id) : '';
      const price = variant?.price_html || root.dataset.tpBasePrice;
      root.querySelector('[data-tp-price]').innerHTML = price;
      const compare = root.querySelector('[data-tp-compare]');
      compare.hidden = !variant?.compare_html;
      compare.innerHTML = variant?.compare_html || '';
      root.querySelector('[data-tp-sticky-price]').innerHTML = price;
      root.querySelector('[data-tp-sticky-size]').textContent = variant ? (sizeIndex >= 0 ? `Mărimea ${variant.options[sizeIndex]}` : 'Varianta selectată') : chooseLabel;
      form.querySelector('[data-tp-product-quantity]').value = variant?.quantity || 1;
      main.disabled = !!variant && !variant.available || !variants.some(v => v.available);
      stickyButton.disabled = main.disabled;
      const label = main.disabled ? 'Indisponibil' : variant ? 'Adaugă în coș' : chooseLabel;
      main.textContent = label;
      stickyButton.textContent = label;
      measurement(variant);
    }
    form.addEventListener('change', event => {
      const group = event.target.closest('[data-tp-option-index]');
      if (!group) return;
      let selected = choices();
      let variant = match(selected);
      if (sizeIndex >= 0 && Number(group.dataset.tpOptionIndex) !== sizeIndex && !variant?.available) {
        const selectedInput = groups[sizeIndex]?.querySelector('input:checked');
        if (selectedInput) selectedInput.checked = false;
        selected = choices(); variant = match(selected);
      }
      update(variant);
      formError(form, '');
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', String(variant.id));
      else url.searchParams.delete('variant');
      history.replaceState(history.state, '', url);
      if (variant?.image_id) {
        const gallery = root.querySelector('[data-tp-pdp-gallery]');
        const slides = gallery ? [...gallery.querySelectorAll('.tp-pdp-slide')] : [];
        const at = slides.findIndex(node => node.dataset.tpImageId === String(variant.image_id));
        /* 02.11.2026 gallery-v2: trecem prin controlerul galeriei (contor + sageti sincronizate pe loc) */
        if (at >= 0) {
          if (gallery.__tpGal) gallery.__tpGal.goTo(at);
          else gallery.scrollTo({ left: slides[at].offsetLeft - gallery.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }
    });
    stickyButton.addEventListener('click', () => {
      if (select.value) { purchaseFocus.set(form, stickyButton); form.requestSubmit(main); }
      else {
        const picker = groups[sizeIndex] || groups[0];
        picker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        picker?.querySelector('input:not(:disabled)')?.focus({ preventScroll: true });
        formError(form, 'Alege o mărime disponibilă.');
      }
    });
    update(variants.find(variant => String(variant.id) === select.value) || (sizeIndex < 0 ? match(choices()) : null));

    const mobile = window.matchMedia('(max-width: 767px)');
    let passedMain = false;
    let stickyFrame = 0;
    function setSticky() {
      stickyFrame = 0;
      sticky.hidden = !(mobile.matches && passedMain);
      document.documentElement.style.setProperty('--tp-app-sticky-height', sticky.hidden ? '0px' : `${sticky.getBoundingClientRect().height}px`);
    }
    /* 30.10.2026: pe telefon bara de cumparare apare de la prima vedere cat timp butonul principal nu se vede (sub fold sau sub bara de jos), nu doar dupa ce l-ai depasit */
    function mainOutOfView() {
      const r = main.getBoundingClientRect();
      const nav = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tp-app-nav-height')) || 64;
      return r.bottom <= 0 || r.bottom > window.innerHeight - nav + 1; /* 30.10.2026 buybar-partial: si cand butonul e acoperit partial de bara de jos */
    }
    function scheduleSticky() {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(() => {
        passedMain = mainOutOfView();
        setSticky();
      });
    }
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        passedMain = mainOutOfView();
        setSticky();
      });
      observer.observe(main);
    }
    // A jump can move the button from above to below without crossing an IO threshold.
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    mobile.addEventListener('change', scheduleSticky);
    if ('ResizeObserver' in window) {
      const resize = new ResizeObserver(scheduleSticky);
      resize.observe(sticky); resize.observe(root);
    }
    passedMain = mainOutOfView();
    setSticky();
  }

  initializeRails();
  initializeFilters();
  initializeCards();
  document.querySelectorAll('[data-tp-product]').forEach(initializeProduct);
  document.addEventListener('shopify:section:load', event => {
    initializeRails(event.target);
    initializeFilters(event.target);
    initializeCards(event.target);
    event.target.querySelectorAll('[data-tp-product]').forEach(initializeProduct);
  });

  // Some apps re-render the product grid after load (recommendations/AB widgets); keep cards wired regardless.
  if ('MutationObserver' in window) {
    let cardObserverTimer = 0;
    const cardObserver = new MutationObserver(() => {
      if (cardObserverTimer) clearTimeout(cardObserverTimer);
      cardObserverTimer = setTimeout(() => { cardObserverTimer = 0; initializeCards(); }, 80);
    });
    cardObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
